<template>
    <div class="gray-back" style="padding:.2rem 0 2rem 0">
        <div class="danwei-warp">

            <div class="cover">
                <img :src="row.pic_url" />

            </div>
            <div class="title">{{row.baoming.danwei}} {{row.baoming.saiqu}}</div>
            <div class="saiqu">{{row.subject_name}}</div>
            <div class="duiwu">{{row.baoming.mingcheng}}</div>
            <div class="member">运动员

                <van-tag plain  v-for="(member,index) in row.yundongyuan" :key="index" >{{member.name}}</van-tag>

            </div>
            <div class="member">教练员
                <van-tag plain  v-for="(member,index) in row.jiaolian" :key="index" >{{member.name}}</van-tag>
            </div>

            <div class="num">
                <div class="count">{{row.vote_count}}</div>
                <span>票</span>
            </div>
        </div>


        <div class="savebtn">

            <van-button
                    style="width: 3rem"
                    size="normal" round @click="all">查看所有</van-button>

            <van-button
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round  @click="vote" >投TA一票</van-button>
        </div>



        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .van-tag{
        margin-right: 10px;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }
    .danwei-warp{
        margin: 0.2rem;
        background: #fff;
        box-shadow:0px 0px 10px 0px rgba(204,204,204,0.5);
        border-radius:0.2rem;
        padding: 0.2rem;
    }
    .danwei-warp .title{
        font-size: 18px;
        color: #000;
        margin: 0.4rem 0.2rem 0.2rem 0.2rem;
        font-weight: bold;
    }
    .danwei-warp .saiqu{
        font-size: 14px;
        margin: 0rem 0.2rem 0.4rem 0.2rem;
        color: #666;
    }
    .danwei-warp .duiwu{
        font-size: 12px;
        margin: 0.4rem 0.2rem 0rem 0.2rem;
        color: #999;
    }
    .between {
        justify-content: space-between;
    }
    .member{
        font-size: 12px;
        color: #333;
        margin: 0.2rem 0.2rem 0rem 0.2rem;
    }
    .cover{
        text-align: center;
    }
    .cover img{
        max-width: 100%;
        border-radius: 0.2rem;
    }

    .num{
        height: 80px;
        width: 80px;
        box-sizing: border-box;
        margin: 20px auto 10px auto;
        text-align: center;
        border-radius: 40px;
        border: 1px solid #ff8917;
    }
    .num .count{
        font-size: 20px;
        font-weight: bold;
        margin-top: 20px;
        color: #ff8917;
    }
    .num span{
        font-size: 14px;
        color: #666;
        margin-top: 10px;
    }

</style>
<script>
    import Vue from 'vue';
    import LoginDialog from '@/components/LoginDialog.vue';

    import {Cell,Field,Area,Form,Divider,Steps,Step, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';


    Vue.use(Cell).use(CellGroup).use(Steps).use(Step).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'VoteDetail',
        components: {
            LoginDialog,
            [Field.name]: Field,
        },
        data: function () {
            return {
                loginShow:false,
                saveLoading:false,
                saiqu_id: this.$route.query.saiqu_id,
                showCaipanPicker:false,
                showJiaolianPicker:false,
                showNumTypePicker:false,
                numTypeColumns: ['身份证', '护照'],
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                row: {
                    id:0,
                    baoming:{
                        saiqu:0
                    },
                    saiqu:{

                    },
                    yundongyuan:[],
                    jiaolian:[]
                },
            }
        },
        filters: {},
        computed:{
        },
        mounted() {

            document.title = '投票详情';
            let that = this;
            that.row.id = this.$route.query.id;
            this.fetch();
        },
        watch: {
        },
        destroyed() {
        },
        methods: {
            fetch(){
                let that = this;
                that.$api.get('/api/isai/votesubjectDetail', {
                    id : that.row.id,
                }, (res) => {
                    that.row = res.data
                    that.wxShare(that.row.share_data.title,that.row.share_data.desc,that.row.share_data.url,that.row.share_data.pic_url );
                })
            },

            all(){
              rbLink({
                  name:'ISaiVoteList',query:{saiqu:this.row.baoming.saiqu}
              });
            },


            loginSuccess(res){
                console.log('-------登录成功--------',res);
                this.loginShow = false;
                this.fetch();
            },

            loginCancel(){
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },

            vote(){
                let that = this;
                console.log('vote')
                that.$api.post('/api/vote/voteadd', {
                    type:'sai',
                    pid1: that.row.id,
                    pid2: that.row.baoming_id,
                    pid3: that.row.baoming.saiqu,
                }, (res) => {
                    console.log('投票成功');
                    that.row.vote_count++;
                    Toast('投票成功');
                }, (res) => {
                    Toast.fail(res.msg);
                    console.log('没有登录');
                    if (res.code == 401 || res.code==402) {
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                })
            },

        }
    }
</script>



// WEBPACK FOOTER //
// VoteDetail.vue?b7d4a4d6